module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('drawer', {
    attrs: {
      "show": _vm.show,
      "position": _vm.position
    }
  }, [_c('header', {
    staticClass: "header header-light"
  }, [_c('div', {
    staticClass: "header-dock al"
  }, [_c('button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")])]), _vm._v(" "), _c('div', {
    staticClass: "header-body"
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "header-dock ar"
  }, [_c('button', {
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-box"
  }, [_c('div', {
    staticClass: "flex-item-1"
  }, [_c('selector', {
    attrs: {
      "title": "时",
      "value": _vm.hourSelf,
      "options": _vm.h,
      "max-height": "200px"
    },
    on: {
      "on-change": _vm.handleHourChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-item-1"
  }, [_c('selector', {
    attrs: {
      "title": "分",
      "value": _vm.minutesSelf,
      "options": _vm.m,
      "max-height": "200px"
    },
    on: {
      "on-change": _vm.handleMinChange
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b1576ad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/selector-time/selector-time.vue
// module id = 230
// module chunks = 4